exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login[data-v-5e6834d8]{height:50%;content:\"\";z-index:0}#login[data-v-5e6834d8],.bg[data-v-5e6834d8]{width:100%;position:absolute;top:0;left:0}.bg[data-v-5e6834d8]{height:100%;background:url(/static/login-background.png) no-repeat 50%;background-size:cover;-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);

// exports
